export default __webpack_public_path__ + "static/media/api.ad324afc.svg";